(function () {
  const bar = document.querySelector(".v3-bar");
  const social = document.querySelector(".v3-social");
  const hero = document.querySelector(".v3-hero");

  const navItems = document.querySelectorAll(".v3-nav__item");
  if (navItems.length) {
    const navLockKey = "v3-nav-lock";
    const persistLock = (id) => {
      try {
        if (id) sessionStorage.setItem(navLockKey, id);
      } catch (err) {}
    };
    const lockItem = (item) => item.classList.add("is-locked");
    const unlockItem = (item) => item.classList.remove("is-locked");

    navItems.forEach((item) => {
      const trigger = item.querySelector(".v3-nav__trigger");
      const panel = item.querySelector(".v3-nav__panel");
      const id = trigger && trigger.getAttribute("aria-controls");
      item.addEventListener("mouseleave", () => unlockItem(item));
      if (trigger) {
        trigger.addEventListener("click", () => {
          persistLock(id);
          lockItem(item);
          trigger.blur();
        });
      }
      if (panel) {
        panel.addEventListener("click", (event) => {
          if (!event.target.closest("a")) return;
          persistLock(id);
          lockItem(item);
          if (trigger) trigger.blur();
        });
      }
    });

    const applyNavLock = () => {
      let lockedId = "";
      try {
        lockedId = sessionStorage.getItem(navLockKey) || "";
        if (lockedId) sessionStorage.removeItem(navLockKey);
      } catch (err) {}
      if (!lockedId) return;
      const trigger = document.querySelector('.v3-nav__trigger[aria-controls="' + lockedId + '"]');
      const item = trigger && trigger.closest(".v3-nav__item");
      if (item) lockItem(item);
    };

    applyNavLock();
    window.addEventListener("pageshow", applyNavLock);
  }

  const brandsPanel = document.querySelector(".v3-nav__panel--brands");
  if (brandsPanel && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const glow = document.createElement("span");
    glow.className = "v3-nav__glow";
    glow.setAttribute("aria-hidden", "true");
    brandsPanel.prepend(glow);
    let x = 0;
    let y = 0;
    let tx = 0;
    let ty = 0;
    let hovering = false;
    let frame = 0;
    const follow = () => {
      x += (tx - x) * 0.14;
      y += (ty - y) * 0.14;
      glow.style.left = x + "px";
      glow.style.top = y + "px";
      if (hovering || Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) {
        frame = requestAnimationFrame(follow);
      } else {
        frame = 0;
      }
    };
    brandsPanel.addEventListener("pointermove", (event) => {
      const box = brandsPanel.getBoundingClientRect();
      tx = event.clientX - box.left;
      ty = event.clientY - box.top;
      if (!hovering) {
        x = tx;
        y = ty;
        hovering = true;
        glow.style.opacity = "1";
      }
      if (!frame) frame = requestAnimationFrame(follow);
    });
    brandsPanel.addEventListener("pointerleave", () => {
      hovering = false;
      glow.style.opacity = "0";
    });
  }

  const logoCycle = document.querySelector("[data-v3-logo-cycle]");
  if (logoCycle) {
    const faces = Array.from(logoCycle.querySelectorAll(".v3-mark__face"));
    const key = "inkd-logo-pick";
    let index = faces.findIndex((face) => face.getAttribute("data-logo") === window.localStorage.getItem(key));
    if (index < 0) index = 0;

    const show = (next) => {
      faces.forEach((face, i) => face.classList.toggle("is-on", i === next));
      const name = faces[next].getAttribute("data-logo") || "logo";
      window.localStorage.setItem(key, name);
      logoCycle.setAttribute("aria-label", "Logo " + name + ". Click for the next one.");
      if (bar) bar.setAttribute("data-logo-pick", name);
    };

    show(index);
    logoCycle.addEventListener("click", () => {
      index = (index + 1) % faces.length;
      show(index);
    });
  }

  if (bar && hero) {
    const flipHeader = () => {
      bar.classList.toggle("is-away", hero.getBoundingClientRect().top < -16);
    };
    window.addEventListener("scroll", flipHeader, { passive: true });
    window.addEventListener("resize", flipHeader);
    flipHeader();
  }

  // Social icons sit fixed near the bottom-right. Flip them to the dark
  // "away" style the moment the hero's bottom edge scrolls above them, so
  // they stay visible over the light sections that follow the hero.
  if (social && hero) {
    const flipSocial = () => {
      const socialTop = social.getBoundingClientRect().top;
      const heroBottom = hero.getBoundingClientRect().bottom;
      social.classList.toggle("is-away", heroBottom < socialTop);
    };
    window.addEventListener("scroll", flipSocial, { passive: true });
    window.addEventListener("resize", flipSocial);
    flipSocial();
  }

  const bindSwipeHint = (track, hint) => {
    if (!track || !hint) return;
    if (track.scrollWidth <= track.clientWidth + 12) {
      hint.hidden = true;
      return;
    }
    const hideSwipe = () => {
      if (track.scrollLeft < 12) return;
      hint.classList.add("is-done");
      track.removeEventListener("scroll", hideSwipe);
    };
    track.addEventListener("scroll", hideSwipe, { passive: true });
  };

  document.querySelectorAll("[data-v3-swipe-track]").forEach((track) => {
    bindSwipeHint(track, track.parentElement.querySelector("[data-v3-swipe]"));
  });
  bindSwipeHint(
    document.querySelector(".v3-work__grid"),
    document.querySelector(".v3-work__swipe")
  );

  const sheet = document.querySelector(".v3-dock__sheet");
  if (sheet) {
    const panel = sheet.querySelector(".v3-dock__panel");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let closing = false;

    sheet.classList.add("is-animated");

    const finishClose = () => {
      sheet.removeAttribute("open");
      sheet.classList.remove("is-open", "is-closing");
      closing = false;
    };

    sheet.addEventListener("toggle", () => {
      if (!sheet.open || closing) return;
      sheet.classList.remove("is-closing");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sheet.classList.add("is-open");
        });
      });
    });

    sheet.querySelector(".v3-dock__btn").addEventListener("click", (event) => {
      if (!sheet.open || closing) return;
      event.preventDefault();
      if (reduce) {
        finishClose();
        return;
      }
      closing = true;
      sheet.classList.add("is-closing");
      sheet.classList.remove("is-open");
      const done = (event) => {
        if (event && event.target !== panel) return;
        panel.removeEventListener("transitionend", done);
        finishClose();
      };
      panel.addEventListener("transitionend", done);
      setTimeout(done, 420);
    });
  }

  const dock = document.querySelector(".v3-dock");
  if (dock) {
    const sampleLuma = (node) => {
      let el = node;
      while (el && el !== document.documentElement) {
        const bg = getComputedStyle(el).backgroundColor;
        const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?/);
        if (match) {
          const alpha = match[4] === undefined ? 1 : Number(match[4]);
          if (alpha > 0.45) {
            return (0.299 * Number(match[1]) + 0.587 * Number(match[2]) + 0.114 * Number(match[3])) / 255;
          }
        }
        el = el.parentElement;
      }
      return 0.9;
    };

    const syncDockContrast = () => {
      if (window.matchMedia("(min-width: 768px)").matches) return;
      const rect = dock.getBoundingClientRect();
      if (!rect.height) return;
      const x = rect.left + 26;
      const y = Math.max(8, rect.top - 8);
      dock.style.pointerEvents = "none";
      const target = document.elementFromPoint(x, y);
      dock.style.pointerEvents = "";
      const luma = target ? sampleLuma(target) : 0.9;
      dock.classList.toggle("is-on-paper", luma > 0.48);
    };

    let dockTick = false;
    const onDockScroll = () => {
      if (dockTick) return;
      dockTick = true;
      requestAnimationFrame(() => {
        dockTick = false;
        syncDockContrast();
      });
    };

    window.addEventListener("scroll", onDockScroll, { passive: true });
    window.addEventListener("resize", onDockScroll);
    document.addEventListener("scroll", onDockScroll, { passive: true, capture: true });
    syncDockContrast();
    setTimeout(syncDockContrast, 350);
  }

  const ai = document.querySelector("[data-v3-ai]");
  if (ai) {
    const form = ai.querySelector("[data-v3-ai-form]");
    const input = ai.querySelector("[data-v3-ai-input]");
    const results = document.querySelector("[data-v3-ai-results]");
    const cards = Array.from(document.querySelectorAll("[data-v3-ai-grid] [data-search]"));
    const countEl = document.querySelector("[data-v3-ai-count]");
    const emptyEl = document.querySelector("[data-v3-ai-empty]");
    const total = cards.length;

    const tokensFrom = (query) => {
      const stop = new Set(["a", "an", "the", "for", "and", "or", "to", "of", "in", "with", "my", "our", "team", "need", "want", "please", "some", "me", "i"]);
      return query
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, " ")
        .split(/\s+/)
        .filter((word) => word.length > 1 && !stop.has(word));
    };

    const expand = (tokens) => {
      const map = {
        hoodie: ["hoodie", "hoodies", "sweatshirt", "fleece"],
        hoodies: ["hoodie", "hoodies", "sweatshirt", "fleece"],
        kit: ["kit", "kits", "welcome", "onboarding"],
        kits: ["kit", "kits", "welcome", "onboarding"],
        welcome: ["welcome", "kit", "kits", "onboarding"],
        drinkware: ["drinkware", "bottle", "mug", "tumbler", "cup"],
        bottle: ["bottle", "bottles", "drinkware", "tumbler"],
        hat: ["hat", "hats", "cap", "beanie"],
        hats: ["hat", "hats", "cap", "beanie"],
        shirt: ["shirt", "tee", "tshirt", "polo"],
        tee: ["tee", "shirt", "tshirt"],
        apparel: ["apparel", "shirt", "hoodie", "hat", "tee"],
        bags: ["bag", "tote", "backpack"],
        office: ["office", "notebook", "pen"],
        events: ["event", "lanyard", "kit"],
      };
      const extra = [];
      tokens.forEach((token) => {
        if (map[token]) extra.push(...map[token]);
      });
      return Array.from(new Set(tokens.concat(extra)));
    };

    const filterCards = (query) => {
      const raw = query.trim().toLowerCase();
      const showAll = raw === "" || raw === "all" || raw === "all products";
      let visible = 0;

      cards.forEach((card) => {
        const haystack = card.getAttribute("data-search") || "";
        let match = showAll;
        if (!showAll) {
          const tokens = expand(tokensFrom(raw));
          match = tokens.some((token) => haystack.includes(token)) || haystack.includes(raw);
        }
        card.classList.toggle("is-hidden", !match);
        if (match) visible += 1;
      });

      if (countEl) {
        countEl.textContent = showAll
          ? `${total} products in the catalog`
          : `${visible} of ${total} products match`;
      }
      if (emptyEl) emptyEl.hidden = visible !== 0 || total === 0;
    };

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const text = input.value.trim();
      if (!text) return;
      filterCards(text);
      if (results) results.hidden = false;
    });
  }

  const shop = document.querySelector("[data-v3-shop]");
  if (shop) {
    const form = shop.querySelector("[data-v3-shop-form]");
    const input = shop.querySelector("[data-v3-shop-input]");
    const cards = Array.from(shop.querySelectorAll("[data-v3-shop-grid] [data-search]"));
    const cats = Array.from(shop.querySelectorAll("[data-v3-shop-cat]"));
    const vendors = Array.from(shop.querySelectorAll("[data-v3-shop-vendor]"));
    const types = Array.from(shop.querySelectorAll("[data-v3-shop-type]"));
    const prices = Array.from(shop.querySelectorAll("[data-v3-shop-price]"));
    const stocks = Array.from(shop.querySelectorAll("[data-v3-shop-stock]"));
    const countEl = shop.querySelector("[data-v3-shop-count]");
    const emptyEl = shop.querySelector("[data-v3-shop-empty]");
    const total = cards.length;
    let cat = cats.find((btn) => btn.classList.contains("is-on"))?.getAttribute("data-v3-shop-cat") || "all";
    let vendor = "all";
    let type = "all";
    let price = "all";
    let stock = "all";

    const tokensFrom = (query) => {
      const stop = new Set(["a", "an", "the", "for", "and", "or", "to", "of", "in", "with", "my", "our", "team", "need", "want", "please", "some", "me", "i"]);
      return query
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, " ")
        .split(/\s+/)
        .filter((word) => word.length > 1 && !stop.has(word));
    };

    const expand = (tokens) => {
      const map = {
        hoodie: ["hoodie", "hoodies", "sweatshirt", "fleece"],
        hoodies: ["hoodie", "hoodies", "sweatshirt", "fleece"],
        kit: ["kit", "kits", "welcome", "onboarding"],
        kits: ["kit", "kits", "welcome", "onboarding"],
        welcome: ["welcome", "kit", "kits", "onboarding"],
        drinkware: ["drinkware", "bottle", "mug", "tumbler", "cup"],
        bottle: ["bottle", "bottles", "drinkware", "tumbler"],
        hat: ["hat", "hats", "cap", "beanie"],
        hats: ["hat", "hats", "cap", "beanie"],
        shirt: ["shirt", "tee", "tshirt", "polo"],
        tee: ["tee", "shirt", "tshirt"],
        apparel: ["apparel", "shirt", "hoodie", "hat", "tee"],
        bags: ["bag", "tote", "backpack"],
        office: ["office", "notebook", "pen", "lanyard"],
        events: ["event", "lanyard", "kit"],
      };
      const extra = [];
      tokens.forEach((token) => {
        if (map[token]) extra.push(...map[token]);
      });
      return Array.from(new Set(tokens.concat(extra)));
    };

    const inPrice = (cents, range) => {
      if (range === "all") return true;
      const value = Number(cents) || 0;
      if (range === "0-2500") return value < 2500;
      if (range === "2500-5000") return value >= 2500 && value < 5000;
      if (range === "5000-10000") return value >= 5000 && value < 10000;
      if (range === "10000") return value >= 10000;
      return true;
    };

    const apply = () => {
      const raw = (input?.value || "").trim().toLowerCase();
      const showAllQuery = raw === "";
      let visible = 0;

      cards.forEach((card) => {
        const haystack = card.getAttribute("data-search") || "";
        const catHay = card.getAttribute("data-cat") || haystack;
        const catOk = cat === "all" || catHay.includes(cat);
        const vendorOk = vendor === "all" || card.getAttribute("data-vendor") === vendor;
        const typeOk = type === "all" || card.getAttribute("data-type") === type;
        const priceOk = inPrice(card.getAttribute("data-price"), price);
        const stockOk = stock === "all" || card.getAttribute("data-available") === "true";
        let searchOk = showAllQuery;
        if (!searchOk) {
          const tokens = expand(tokensFrom(raw));
          searchOk = tokens.some((token) => haystack.includes(token)) || haystack.includes(raw);
        }
        const match = catOk && vendorOk && typeOk && priceOk && stockOk && searchOk;
        card.classList.toggle("is-hidden", !match);
        if (match) visible += 1;
      });

      if (countEl) {
        countEl.textContent = `${visible} of ${total}`;
      }
      if (emptyEl) emptyEl.hidden = visible !== 0 || total === 0;
    };

    const bindGroup = (buttons, key, setter) => {
      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          setter(btn.getAttribute(key) || "all");
          buttons.forEach((item) => item.classList.toggle("is-on", item === btn));
          apply();
        });
      });
    };

    bindGroup(cats, "data-v3-shop-cat", (value) => { cat = value; });
    bindGroup(vendors, "data-v3-shop-vendor", (value) => { vendor = value; });
    bindGroup(types, "data-v3-shop-type", (value) => { type = value; });
    bindGroup(prices, "data-v3-shop-price", (value) => { price = value; });
    bindGroup(stocks, "data-v3-shop-stock", (value) => { stock = value; });

    form?.addEventListener("submit", (event) => {
      event.preventDefault();
      apply();
    });

    input?.addEventListener("input", apply);
    apply();

    const bindRail = (pane, axis) => {
      const wrap = pane.parentElement;
      const rail = wrap?.querySelector(`.v3-shop__rail--${axis}`);
      const track = rail?.querySelector(".v3-shop__rail-track");
      const thumb = rail?.querySelector(".v3-shop__rail-thumb");
      if (!wrap || !rail || !track || !thumb) return;

      const isX = axis === "x";
      let dragging = false;
      let dragStart = 0;
      let scrollStart = 0;

      const metrics = () => {
        const view = isX ? pane.clientWidth : pane.clientHeight;
        const total = isX ? pane.scrollWidth : pane.scrollHeight;
        const trackSize = isX ? track.clientWidth : track.clientHeight;
        const thumbSize = Math.max(Math.min((view / Math.max(total, 1)) * trackSize, trackSize), 28);
        return {
          view,
          total,
          thumbSize,
          maxThumb: Math.max(trackSize - thumbSize, 1),
          maxScroll: Math.max(total - view, 1),
        };
      };

      const update = () => {
        const size = metrics();
        const overflow = size.total > size.view + 2;
        wrap.classList.toggle("has-rail", overflow);
        if (!overflow) return;

        const progress = Math.min(Math.max((isX ? pane.scrollLeft : pane.scrollTop) / size.maxScroll, 0), 1);
        if (isX) {
          thumb.style.width = `${size.thumbSize}px`;
          thumb.style.height = "100%";
          thumb.style.transform = `translate3d(${progress * size.maxThumb}px,0,0)`;
        } else {
          thumb.style.height = `${size.thumbSize}px`;
          thumb.style.width = "100%";
          thumb.style.transform = `translate3d(0,${progress * size.maxThumb}px,0)`;
        }
      };

      const onPointerMove = (event) => {
        if (!dragging) return;
        const size = metrics();
        const delta = (isX ? event.clientX : event.clientY) - dragStart;
        const next = scrollStart + (delta / size.maxThumb) * size.maxScroll;
        if (isX) pane.scrollLeft = next;
        else pane.scrollTop = next;
      };

      const stopDrag = () => {
        dragging = false;
        rail.classList.remove("is-dragging");
      };

      thumb.addEventListener("pointerdown", (event) => {
        event.preventDefault();
        dragging = true;
        dragStart = isX ? event.clientX : event.clientY;
        scrollStart = isX ? pane.scrollLeft : pane.scrollTop;
        thumb.setPointerCapture(event.pointerId);
        rail.classList.add("is-dragging");
      });
      thumb.addEventListener("pointermove", onPointerMove);
      thumb.addEventListener("pointerup", stopDrag);
      thumb.addEventListener("pointercancel", stopDrag);

      rail.addEventListener("pointerdown", (event) => {
        if (event.target === thumb || thumb.contains(event.target)) return;
        const rect = track.getBoundingClientRect();
        const size = metrics();
        const click = isX ? event.clientX - rect.left : event.clientY - rect.top;
        const progress = Math.min(Math.max((click - size.thumbSize / 2) / size.maxThumb, 0), 1);
        if (isX) pane.scrollLeft = progress * size.maxScroll;
        else pane.scrollTop = progress * size.maxScroll;
      });

      pane.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    };

    const catsPane = shop.querySelector('[data-v3-pane="x"]');
    const filtersPane = shop.querySelector('[data-v3-pane="y"]');
    if (catsPane) bindRail(catsPane, "x");
    if (filtersPane) bindRail(filtersPane, "y");
  }

  const faqEase = "height 0.4s cubic-bezier(0.22, 1, 0.36, 1)";
  const faqReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll(".v3-faq details").forEach((item) => {
    const summary = item.querySelector("summary");
    const panel = item.querySelector(".v3-faq__panel");
    if (!summary || !panel) return;

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (item.open) {
        if (faqReduce) {
          item.open = false;
          return;
        }
        panel.style.height = panel.scrollHeight + "px";
        panel.style.transition = faqEase;
        requestAnimationFrame(() => {
          panel.style.height = "0px";
        });
        panel.addEventListener("transitionend", () => {
          item.open = false;
          panel.style.height = "";
          panel.style.transition = "";
        }, { once: true });
      } else {
        item.open = true;
        if (faqReduce) return;
        panel.style.height = "0px";
        const height = panel.scrollHeight;
        requestAnimationFrame(() => {
          panel.style.transition = faqEase;
          panel.style.height = height + "px";
        });
        panel.addEventListener("transitionend", () => {
          panel.style.height = "auto";
          panel.style.transition = "";
        }, { once: true });
      }
    });
  });

  const cartWrap = document.querySelector("[data-v3-cart]");
  if (cartWrap) {
    const trigger = cartWrap.querySelector(".v3-bar__cart");
    const panel = cartWrap.querySelector("[data-v3-cart-panel]");
    const itemsEl = cartWrap.querySelector("[data-v3-cart-items]");
    const summaryEl = cartWrap.querySelector("[data-v3-cart-summary]");
    const footEl = cartWrap.querySelector("[data-v3-cart-foot]");
    const totalEl = cartWrap.querySelector("[data-v3-cart-total]");
    const countEls = document.querySelectorAll("[data-v3-cart-count]");
    const changeUrl = panel.dataset.changeUrl;
    const moneyFormat = panel.dataset.money || "${{amount}}";
    const hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)");

    const setOpen = (open) => {
      cartWrap.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    };

    const formatMoney = (cents) => {
      const value = (Math.round(Number(cents) || 0) / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        if (key === "amount_no_decimals") return String(Math.round(cents / 100));
        if (key === "amount_with_comma_separator") return value.replace(".", ",");
        return value;
      });
    };

    const escapeHtml = (value) =>
      String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/"/g, "&quot;");

    const renderCart = (cart) => {
      const count = cart.item_count || 0;
      countEls.forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      summaryEl.textContent = count
        ? count + (count === 1 ? " piece" : " pieces")
        : "Empty";
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      if (footEl) footEl.hidden = count === 0;

      if (!count) {
        itemsEl.innerHTML = '<p class="v3-mini-cart__empty">Nothing in the bag yet.</p>';
        return;
      }

      itemsEl.innerHTML =
        '<ul class="v3-mini-cart__list">' +
        cart.items
          .map((item) => {
            const image = item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" width="240" height="240" loading="lazy">`
              : "";
            const variant =
              item.variant_title && item.variant_title !== "Default Title"
                ? `<p>${escapeHtml(item.variant_title)}</p>`
                : "";
            return `<li class="v3-mini-cart__item" data-key="${escapeHtml(item.key)}">
              <a class="v3-mini-cart__thumb" href="${escapeHtml(item.url)}">${image}</a>
              <div class="v3-mini-cart__meta">
                <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
                ${variant}
                <p>${formatMoney(item.final_line_price)}</p>
                <div class="v3-mini-cart__row">
                  <div class="v3-mini-cart__qty">
                    <button type="button" data-v3-qty="-1" aria-label="Decrease quantity">−</button>
                    <span>${item.quantity}</span>
                    <button type="button" data-v3-qty="1" aria-label="Increase quantity">+</button>
                  </div>
                  <button type="button" class="v3-mini-cart__remove" data-v3-qty="0">Remove</button>
                </div>
              </div>
            </li>`;
          })
          .join("") +
        "</ul>";
    };

    const changeQty = async (key, quantity) => {
      const res = await fetch(changeUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) return;
      renderCart(await res.json());
    };

    trigger.addEventListener("click", (event) => {
      if (hoverFine.matches) return;
      event.preventDefault();
      setOpen(!cartWrap.classList.contains("is-open"));
    });

    document.addEventListener("click", (event) => {
      if (hoverFine.matches) return;
      if (cartWrap.contains(event.target) || event.target.closest("[data-v3-cart-open]")) return;
      setOpen(false);
    });

    document.querySelectorAll("[data-v3-cart-open]").forEach((btn) => {
      btn.addEventListener("click", () => setOpen(true));
    });

    panel.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-v3-qty]");
      if (!btn) return;
      const item = btn.closest("[data-key]");
      if (!item) return;
      const qtyEl = item.querySelector(".v3-mini-cart__qty span");
      const current = Number(qtyEl ? qtyEl.textContent : 0);
      const delta = Number(btn.dataset.v3Qty);
      const next = delta === 0 ? 0 : Math.max(0, current + delta);
      changeQty(item.dataset.key, next);
    });
  }

  // ===== Policy pages (Terms / Privacy) — simple centered date =====
  // Shopify renders its own .shopify-policy__* markup (ignores policy.liquid).
  const policy = document.querySelector(".shopify-policy__container");
  if (policy) {
    const body = policy.querySelector(".shopify-policy__body .rte") || policy.querySelector(".shopify-policy__body");
    const dateP = body ? body.querySelector("p") : null;
    const dateText = dateP ? dateP.textContent.trim() : "";
    const dateLabel = /effective/i.test(dateText) ? "Effective date" : "Last updated";
    const dateValue = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

    const date = document.createElement("p");
    date.className = "v3-policy-date";
    date.textContent = dateLabel + ": " + dateValue;

    const title = policy.querySelector(".shopify-policy__title");
    if (title) title.appendChild(date);
  }

  const inspireBrands = document.querySelector("[data-inspire-brands]");
  if (inspireBrands && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const viewport = inspireBrands.querySelector(".v3-inspire__brands-viewport");
    const track = inspireBrands.querySelector(".v3-inspire__brands-track");
    const first = inspireBrands.querySelector(".v3-inspire__brands");
    const imgs = first ? Array.from(first.querySelectorAll("img")) : [];

    const measure = () => {
      if (!viewport || !first || !track) return;
      inspireBrands.classList.remove("is-marquee", "is-ready", "is-static");
      inspireBrands.classList.add("is-measuring");
      const overflow = first.scrollWidth > viewport.clientWidth + 12;
      inspireBrands.classList.remove("is-measuring");
      if (overflow) {
        const seconds = Math.max(28, Math.min(64, Math.round(first.scrollWidth / 28)));
        track.style.setProperty("--v3-inspire-brands-dur", seconds + "s");
        inspireBrands.classList.add("is-marquee", "is-ready");
      } else {
        track.style.removeProperty("--v3-inspire-brands-dur");
        inspireBrands.classList.add("is-static");
      }
    };

    const waits = imgs.map((img) => {
      if (img.decode) return img.decode().catch(() => {});
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
      });
    });

    let resizeTimer = 0;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 120);
    };

    Promise.all(waits).then(measure);
    measure();
    window.addEventListener("resize", onResize);
  }

})();
